import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { Button } from 't3-widgets'

import { DeviceTypeHandler } from '../../../../../common/components/device-type-handler/device-type-handler'

import styles from './navigation-bar.module.css'

const NavigationBar = ({ activeStep, intl, onActivate, onBack, onFinish, onNext, steps, valid }) => {
    const fetchTranslateSuccess = useSelector(state => state.fetchTranslateSuccess.fetchTranslateSuccess)

    return fetchTranslateSuccess ? (
        <div className={styles['navigation-buttons-container']}>
            <div className={styles['component-slot']} />
            <div className={styles['navigation-buttons']}>
                {activeStep < steps.length - 2 && (
                    <div className={styles['navigation-button-item']}>
                        <Button disabled={!valid} onClick={onNext} primary>
                            {intl.translate('btn_next')}
                        </Button>
                    </div>
                )}
                {activeStep === steps.length - 1 && (
                    <DeviceTypeHandler
                        desktopDeviceComponent={
                            <div className={styles['navigation-button-item']}>
                                <Button disabled={!valid} onClick={onFinish} primary>
                                    {intl.translate('btn_activate_more_devices')}
                                </Button>
                            </div>
                        }
                        mobileDeviceComponent={<div />}
                    />
                )}
                {activeStep === steps.length - 2 && (
                    <div className={styles['navigation-button-item']}>
                        <Button className={styles['activate-button']} disabled={!valid} onClick={onActivate} primary>
                            {intl.translate('btn_activate')}
                        </Button>
                    </div>
                )}
                {activeStep > 0 && !(activeStep === steps.length - 1) && (
                    <div className={styles['navigation-button-item']}>
                        <Button onClick={onBack}>{intl.translate('btn_back')}</Button>
                    </div>
                )}
            </div>
        </div>
    ) : (
        <div />
    )
}

NavigationBar.propTypes = {
    activeStep: PropTypes.boolean,
    intl: PropTypes.objectOf(PropTypes.func),
    onActivate: PropTypes.func,
    onBack: PropTypes.func,
    onFinish: PropTypes.func,
    onNext: PropTypes.func,
    steps: PropTypes.array,
    valid: PropTypes.boolean
}

export { NavigationBar }
